import type { RangePreset } from '../components/intel/RangeControl';

/**
 * SF-171: race/rank/percent-preset option lists shared by desktop's `TargetFinderTab.tsx` and the
 * new `MobileTargetFilterSheet.tsx` — previously module-private consts inside `TargetFinderTab.tsx`
 * (a `.tsx` file, so exporting them directly there would trip
 * `react-refresh/only-export-components`, per CLAUDE.md's standing convention). Single source of
 * truth so the two filter sheets can't silently diverge on which races/ranks are selectable.
 *
 * Prefixed `TARGET_FINDER_` (not bare `RACES`/`RANKS`) — `constants/game.ts` already exports a
 * `RACES` const (an array of `{id, name}` objects, a different shape) under the identical
 * identifier; per CLAUDE.md's constant-extraction grep rule, colliding names are only safe until
 * something imports both modules.
 */
export const TARGET_FINDER_RACES = ['AVIAN', 'DWARF', 'ELF', 'FAERY', 'HALFLING', 'HUMAN', 'ORC', 'UNDEAD'];
export const TARGET_FINDER_RANKS = ['PEASANT', 'KNIGHT', 'LORD', 'BARON', 'VISCOUNT', 'COUNT', 'MARQUIS', 'DUKE', 'PRINCE'];

export const TARGET_FINDER_PRESETS: RangePreset[] = [
  { label: '±20%', lower: 80, upper: 120 },
  { label: '±10%', lower: 90, upper: 110 },
  { label: '50–80%', lower: 50, upper: 80 },
  { label: 'Custom', lower: null, upper: null },
];
